module.exports = __webpack_public_path__ + "public/img/top-r.e3194ae2.png";